import { render, staticRenderFns } from "./requests-table.vue?vue&type=template&id=07e1250c&"
import script from "./requests-table.vue?vue&type=script&lang=js&"
export * from "./requests-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports